var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgTidal = function SvgTidal(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm2.314-11.28 2.33-2.25 1.07 1.037c.42.405.836.808 1.255 1.215l-.155.15-2.17 2.1-2.33-2.247c-.59.57-1.17 1.13-1.758 1.7l-.564.546.733.71 1.589 1.541-.5.484-1.827 1.767-2.328-2.25.752-.729 1.57-1.522-1.293-1.252-1.029-.995-1.425 1.376-.004.003-.9.869-1.374-1.327-.003-.003-.953-.92 1.343-1.3.986-.954.159.153 2.173 2.097.862-.835 1.463-1.416 1.466 1.418.862.833Z",
    fill: "currentColor"
  })));
};
export default SvgTidal;